'use client'
import React, { useCallback, useState } from 'react'
import { Box, Button, Flex, Image, Link, Text } from '@chakra-ui/react'
import Calendar from '../modals/calendar'
import { useSearchParams } from 'next/navigation'

const WalletCycle = () => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false)
  const searchParams = useSearchParams()

  const handleCalendarOpen = () => {
    setIsCalendarOpen(true)
  }

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams.toString())
      params.set(name, value)

      return params.toString()
    },
    [searchParams]
  )

  return (
    <>
      <Calendar
        isOpen={isCalendarOpen}
        onClose={() => setIsCalendarOpen(false)}
      />
      <Box className="mb-2 rounded-2xl border-2 border-[#DDDDDD]">
        <div className="h-4 w-full rounded-t-2xl bg-[#ED837F]"></div>

        <Flex className="flex-col p-4">
          <Flex className="flex-col">
            <Image
              src={'/rewards/Calendar.svg'}
              alt="Icon"
              w={8}
              h={8}
              mb={1}
            />
            <Text className="my-1 text-[16px] font-semibold text-[#ED837F]">
              Wallet Cycle
            </Text>
            <Text
              lineHeight={'normal'}
              className="mb-1.5 text-sm font-normal text-[#656565]"
            >
              LYKSTAGE wallet statement closes on the 21st of every month, which
              means one cycle is 22nd of the previous month to the 21st of
              the current month, settle on the 7th of the following month.{' '}
            </Text>
          </Flex>

          <Button
            className="mb-3 mt-5 w-full no-underline"
            py={{ base: 5, sm: 6 }}
            bg="#E9E9E9"
            color="#656565"
            fontSize={16}
            _hover={{ opacity: 0.7 }}
            fontWeight={{ base: 400, sm: 500 }}
            textDecoration={'none'}
            onClick={handleCalendarOpen}
          >
            Learn more
          </Button>

          <Link
            href={`/faqs?${createQueryString('query', "Why aren't my earnings updating")}`}
            className="text-center text-sm font-medium"
            textDecorationLine={'underline'}
            color={'#24BFA3'}
          >
            Why your earnings aren’t growing?
          </Link>
        </Flex>
      </Box>
    </>
  )
}

export default WalletCycle
